import { formatMoney, currencySymbol } from "../../currency";

export default class Klaviyo {
  constructor() {
    window._learnq = window._learnq || [];
  }

  name() {
    return "Klaviyo";
  }

  viewedProduct(data) {
    window._learnq.push(["track", "Viewed Product", data]);
    window._learnq.push([
      "trackViewedItem",
      {
        Title: data.Name,
        ItemId: data.ProductID,
        Categories: data.Categories,
        ImageUrl: data.ImageURL,
        Url: data.URL,
        Metadata: {
          Brand: data.Brand,
          Price: data.Price,
          CompareAtPrice: data.CompareAtPrice,
        },
      },
    ]);
  }

  addedToCart(data) {
    const lineItem = data.cart.items.find((item) => data.item.id === item.id);
    let productJson;
    if (document.querySelector(".js-product-json")) {
      productJson = JSON.parse(
        document.querySelector(".js-product-json").innerHTML
      );
    }

    const price = `${currencySymbol()}${formatMoney(
      lineItem.price,
      "{{ amount }}"
    )}`;

    const klaviyoData = {
      Name: lineItem.title,
      ProductID: lineItem.variant_id,
      Categories: productJson ? productJson.productCollections : null,
      ImageURL: lineItem.image,
      URL: `${productJson ? productJson.shopSecureUrl : ""}${lineItem.url}`,
      Brand: lineItem.vendor,
      Price: price,
      CompareAtPrice: price,
    };
    window._learnq.push(["track", "Added to Cart", klaviyoData]);
  }

  bundleAddedToCart(data) {
    const { product, productUrl, productCollections } = JSON.parse(
      document.querySelector(".js-product-json").innerHTML
    );

    const price = `${currencySymbol()}${formatMoney(
      product.price,
      "{{ amount }}"
    )}`;
    const compareAtPriceMax = `${currencySymbol()}${formatMoney(
      product.compare_at_price_max,
      "{{ amount }}"
    )}`;

    const klaviyoData = {
      Name: product.title,
      ProductID: product.id,
      Categories: productCollections,
      ImageURL: product.featured_Image,
      URL: productUrl,
      Brand: product.vendor,
      Price: price,
      CompareAtPrice: compareAtPriceMax,
    };
    window._learnq.push(["track", "Added to Cart", klaviyoData]);
  }

  startedCheckout(data) {
    const lineItems = [];
    data.lineItems.forEach((item) => {
      lineItems.push({
        ProductID: item.variantId,
        SKU: item.variantSku,
        ProductName: item.variantTitle,
        Quantity: item.lineItemQuantity,
        ItemPrice: parseFloat(formatMoney(item.lineItemPrice, "{{ amount }}")),
        RowTotal: parseFloat(
          formatMoney(item.lineItemRowTotal, "{{ amount }}")
        ),
        ProductURL: item.variantUrl,
        ImageURL: item.variantImage,
        ProductCategories: item.categories,
      });
    });

    const eventId = `${data.checkoutId}_${Date.now()}`;
    const itemNames = data.lineItems.map((item) => item.variantTitle);
    let categories = data.lineItems.map((item) => item.categories);
    categories = [...new Set(...categories)];

    const klaviyoData = {
      $event_id: eventId,
      $value: parseFloat(formatMoney(data.checkoutTotal, "{{ amount }}")),
      ItemNames: itemNames,
      CheckoutURL: data.checkoutUrl,
      Categories: categories,
      Items: lineItems,
    };

    window._learnq.push(["track", "Started Checkout", klaviyoData]);
  }
}
